// Ordered tab names for LayoutSidebar b-tabs. Use to avoid magic numbers.
const TAB_NAMES = [
  'Settings',
  'Properties',
  'Layers',
  'Content',
  'Files',
  'Shadows',
  'Translate',
  'Gradient Fill',
  'Effects',
  'Animations',
  'Fields',
  'Background Color Editor',
  'Theme',
  'Comments',
  'Brief',
  'Screen Recording',
  'Clipboard',
  'Design AI',
];

// Map of tab name constants to their indices
export const TAB_INDEX = Object.freeze(
  TAB_NAMES.reduce((acc, name, idx) => {
    acc[name.toUpperCase().replace(/[^A-Z0-9]+/g, '_')] = idx;
    return acc;
  }, {})
);
